import Layout from "../components/layout/Layout";
import AuthGuard from "../guard/authGuard";
import Dashboard from "../pages/Dashboard";
import { dcsRouter } from "./dcsRouter";
import { sysRouter } from "./sysRouter";

export const indexRouter: any = {
  path: "/",
  element: (
    <AuthGuard>
      <Layout />
    </AuthGuard>
  ),
  children: [{ path: "dashboard", element: <Dashboard /> }, ...sysRouter, ...dcsRouter],
};
